import { render } from "./listadoinformacion.vue?vue&type=template&id=5b1bf98b&scoped=true"
import script from "./listadoinformacion.vue?vue&type=script&lang=js"
export * from "./listadoinformacion.vue?vue&type=script&lang=js"

import "./listadoinformacion.vue?vue&type=style&index=0&id=5b1bf98b&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1bf98b"]])

export default __exports__